import React from 'react';
import styled from '@emotion/styled';
import { H1 } from 'components/typography';

const Hero = styled.div`
  background: ${({ theme }) => theme.palette.GREEN};
  color: ${({ theme }) => theme.palette.WHITE};
  padding: 40px 10px;
  text-align: center;
`;

const Content = styled.div`
  max-width: ${({ theme }) => theme.width.medium};
  margin: auto;
`;

const Title = styled(H1)`
  color: ${({ theme }) => theme.palette.BEIGE};
`;

const PageHero = ({ title, text }) => (
  <Hero>
    <Content>
      <Title>{title}</Title>
      <span>{text}</span>
    </Content>
  </Hero>
);

export default PageHero;
